import React, { useRef, useEffect, ReactNode } from 'react';

interface OutsideClickHandlerProps {
  children: ReactNode;
  exceptionRef?: React.RefObject<HTMLElement>;
  onMove?: (event: MouseEvent) => void;
  onMouseUp?: (event: MouseEvent) => void;
  className?: string;
}

const MouseMoveHandler: React.FC<OutsideClickHandlerProps> = ({
  children,
  exceptionRef,
  onMove,
  onMouseUp,
  className = '',
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!onMove) {
      return;
    }
    const handleMoveListener = (event: MouseEvent) => {
      onMove(event);
    };

    document.addEventListener('mousemove', handleMoveListener);

    return () => {
      document.removeEventListener('mousemove', handleMoveListener);
    };
  }, [exceptionRef, onMove]);

  useEffect(() => {
    if (!onMouseUp) {
      return;
    }
    const handleMouseUpListener = (event: MouseEvent) => {
      onMouseUp(event);
    };

    document.addEventListener('mouseup', handleMouseUpListener);

    return () => {
      document.removeEventListener('mouseup', handleMouseUpListener);
    };
  }, [exceptionRef, onMouseUp]);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default MouseMoveHandler;
